<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.sopz.id != null ? 'Opzione sondaggio #' + this.sopz.id : 'Nuova opzione sondaggio') + ' - ' + this.domandasondaggioscheda">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || sopz.id == null) && this.showdettaglio2">
                         <b-row class="my-1">
                                    <b-col sm="3"><label for="risposta">Opzione risposta:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="sopz.risposta" id="risposta" type="text"></b-form-input>
                                    </b-col>
                                </b-row>                                

                                <b-row class="my-1" v-if="sopz.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="sopz.datains" id="datains" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>                                
                                <b-row class="my-1" v-if="sopz.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="sopz.uteins" id="uteins" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-3">
                                    <b-col sm="5" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">                                            
                                            <div v-if="sopz.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>                                            
                                        </b-button>
                                    </b-col>
                                    <b-col sm="4">
                                        <b-button v-if="sopz.id != null" block size="md" variant="outline-secondary" v-on:click="risultati()">
                                            Risultati opzione
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>

                </b-card>
            </b-col>
        </b-row>
    </b-container>
    
</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Partecipa,
    Categoria,
    Socio,
    Visibilità
} from '../classes.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {                        
            namespace: NAMESPACE,
            sopz: {
                id: this.$route.params.id,
                id_scheda: this.$route.params.id_scheda,
                tipo: this.$route.params.tipo,
                risposta: '',
                datains: null
            },  

            domandasondaggioscheda: '',
            error: '',
            showerror: false,
            showdettaglio: false,
            showdettaglio2: false,
            dismissSecs: 2,
            dismissCountDown: 0,        
        };
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        risultati() {
            this.$router.push(`/app/sondaggiorisposte/id_scheda/${this.id}/tipo/${this.tipo}/id_sondaggioopzione/${this.id}`); 
        },
        insert() {

                var appdettaglio = this;

                    if (this.sopz.risposta.trim() == "") {
                        alert("Campo opzione risposta vuoto!");
                        return;
                    }
                                       
                    var sopzAux = this.sopz;

                    var json = JSON.stringify(sopzAux);

                    //console.log(json);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/sondaggioopzione', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {

                                    this.showerror = false;
                                    this.showdettaglio = this.showdettaglio2 = true;                                
                                    this.dismissCountDown = this.dismissSecs;  
                                    
                                    this.$router.replace('/app/dettagliosondaggioopzione/id/' + this.sopz.id + '/id_scheda/' + this.sopz.id_scheda + '/tipo/' + this.sopz.tipo);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
                

            }

    },
    created: function () {

            if(!ctrlVismenu("E")){
                this.$router.replace('/accessdenied');
                return;
            }
            
            var id = this.sopz.id; //se è la prima volta si prova a prendere da getid 

            var appdettaglio = this;

            if(this.sopz.tipo == 'E'){

                var token = localStorage.getItem('token'); 

                this.axios.get(NAMESPACE + 'rest/eventi/' + this.sopz.id_scheda, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.domandasondaggioscheda = res[0].domandasondaggio;

                                    this.showdettaglio2 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

            if (id != null) {

                var token = localStorage.getItem('token');                

                this.axios.get(NAMESPACE + 'rest/sondaggioopzioni/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {                                    
                                    this.sopz = res[0];

                                    this.showdettaglio = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

    }

}
</script>
